import { TextField } from '@cinesend/ui-kit'
import capitalize from '../../helpers/capitalize'
import { Lock } from '@phosphor-icons/react'

const Type = ({ field }) => {
  return (
    <TextField label='Field type' trailingContent={<Lock size={20} />} value={capitalize(field.field_type)} disabled />
  )
}

export default Type
